import {WarehouseType} from 'app/blocks/model/warehouse-type.model';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Resource} from 'app/constants/resource';
import {IWarehouseType} from 'app/blocks/model/warehouse-type.model';
import EntityCrudService from 'app/blocks/service/api/entity-service';

@Injectable({
    providedIn: 'root'
})
export class WarehouseTypeService extends EntityCrudService<IWarehouseType> {
    constructor(http: HttpClient) {
        super(http, Resource.WAREHOUSE_TYPES, (obj?) => new WarehouseType(obj));
    }
}
